<template>
	<section>

		<main class="container mt-12 py-12">
			<div class="row">
				<div class="col mt-24 text-center">
					<h2 class="mt-12">{{ $t('checkin.title') }}</h2>
					<p class="pb-12">{{ $t('message.doubleLastNamesFound') }}</p>

					<form class="needs-validation" novalidate>
						<div class="row justify-content-center" v-for="(guest, index) in $parent.guest">
							<div class="col-md-6 text-center">
								<div class="btn-wrap mb-12">
									<a @click.prevent="nextStep" class="btn btn-primary btn-gold w-100" :data-guestid="index" >
                    <span v-if="guest.lastname">{{guest.lastname}}, {{guest.firstname}}</span><span v-else>{{guest.company}}</span> - {{ $t('booking.checkInTable.tableheader.roomnumber') }} {{guest.roomNumber}}</a>
								</div>
							</div>
						</div>

						<div class="row pt-3">
							<div class="col-md-3 text-left">
								<a @click.prevent="lastStep" class="btn btn-secondary btn-prev">{{ $t('checkin.cancel') }}</a>
							</div>
							<div class="col-md-6 pt-3 dots">
								<p><span class="dot active"></span> <span class="dot"></span> <span class="dot"></span></p>
							</div>

							<div v-if="false" class="col-md-3 text-right">
								<button @click.prevent="nextStep" class="btn btn-primary btn-next" type="submit">{{ $t('checkin.next') }}</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</main>
	</section>
</template>

<script>

    import axios from 'axios'
	import { mapState } from 'vuex';

    export default {
        props: [],
        data: function () {
            return {
              guestZip: null,
				      showError: false
            }
		},
		computed: {
			...mapState('settings', ['config']),
		},
        methods: {
          lastStep() {
            this.$parent.direction = false;
            this.$parent.guest = null;
            this.$parent.component = 'CheckinLogin';
          },
          nextStep(e) {
            this.$parent.visible = false;
            let isGuestCheck = false;
            let self = this;

            self.showError = false;
            this.$parent.guest = this.$parent.guest[e.target.dataset.guestid]
            self.$parent.component = 'CheckinForm';
          },

	        /** Keyboard Events **/
	        accept(text) {
		        this.$parent.accept(text);
	        },
	        show(e) {
		        this.$parent.show(e);
	        },

	        hide() {
		        this.$parent.hide();
	        },

	        next() {
		        this.$parent.next();
	        }


        },
        components: {}
    }
</script>

<style scoped lang="scss">

</style>
